import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError, retry } from 'rxjs/operators';
import { ProductCategoryModel } from '../models/product.category.model';
import { ProductSubCategoryModel } from '../models/product.sub.category.model';
import { PrintGroupModel } from '../models/product.printgroup.model';
import { ProductNomenclatureModel } from '../models/product.nomenclature.model';
import { SpecpageComponent } from '../specpage/specpage.component';
import { ProductSpecpageModel } from '../models/product.specpage.model';
import { ProductCompatibleItemModel } from '../models/product.compatibleitem.model';
import { environment } from 'src/environments/environment';

@Injectable()
export class ProductCategoryService {

  constructor(private http: HttpClient) {
  }

  //productCategoryServiceUrl = 'http://localhost/api/products';
  //productCategoryServiceUrl = 'https://localhost:44320/api/Products';
  productCategoryServiceUrl = environment.apiBaseURI;

  public getProductCategories(): Observable<ProductCategoryModel[]> {
    var data = this.http.get<ProductCategoryModel[]>(this.productCategoryServiceUrl + "/pub/Products");
    return data;
  }


  public getProductSubCategoriesByProductCategoryId(productCategoryId: string): Observable<ProductSubCategoryModel[]> {
    var data = this.http.get<ProductSubCategoryModel[]>(this.productCategoryServiceUrl + "/pub/Products" + "/" + productCategoryId + "/subcategories");
    return data;
  }

  public getPrintGroupsBySubCategoryId(productSubCategoryId: string): Observable<PrintGroupModel[]> {
    var data = this.http.get<PrintGroupModel[]>(this.productCategoryServiceUrl + "/pub/Products" + "/" + productSubCategoryId + "/printgroups");
    return data;
  }


  public getNomenclaturesFromSubCategoryAndPrintGroup(productSubCategoryId: string, designName: string, isEcotainer: boolean, isCompliancePackaging: boolean): Observable<ProductNomenclatureModel[]> {
    var data = this.http.get<ProductNomenclatureModel[]>(this.productCategoryServiceUrl + "/pub/Products" + "/" + productSubCategoryId + "/" + designName + '&isEcotainer=' + isEcotainer + '&isCompliancePackaging=' + isCompliancePackaging);
    return data;
  }
  public getSpecpageData(productId: number): Observable<ProductSpecpageModel[]> {
    var data = this.http.get<ProductSpecpageModel[]>(this.productCategoryServiceUrl + "/pub/Products" + "/" + productId);
    return data;
  }
  public getSpecpageCompatibleItems(nomenclature: string): Observable<ProductCompatibleItemModel[]> {
    var data = this.http.get<ProductCompatibleItemModel[]>(this.productCategoryServiceUrl + "/pub/Products" + "/" + "GetCompatibleItemsForSpecPage" + "/" + nomenclature);
    return data;
  }
  public getSearchResults(nomenclature: string): Observable<ProductNomenclatureModel[]> {
    var data = this.http.get<ProductNomenclatureModel[]>(this.productCategoryServiceUrl + "/pub/Products" + "/search/" + nomenclature + "/");
    return data;
  }
  public getProductIdByPartNumber(partnumber: string): Observable<string> {
    var data = this.http.get<string>(this.productCategoryServiceUrl + "/pub/Products" + "/searchbypartnumber/" + partnumber + "/");
    return data;
  }
  public getPDFPageData(productId: number, casePack: string): Observable<ProductSpecpageModel[]> {
    var data = this.http.get<ProductSpecpageModel[]>(this.productCategoryServiceUrl + "/pub/Products" + "/" + productId + "&casePack=" + casePack);
    return data;
  }

  //***###Temporary Stuff. To be handled better in the next version. */
  public DownloadSpec(id: number) {
    let headers = new HttpHeaders();
    headers = headers.set('Accept', 'application/pdf');
    return this.http.get(this.productCategoryServiceUrl + "/pub/Products/DownloadSpecs/" + id, { headers: headers, responseType: 'blob' as 'json' });
  }
}
